import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

import config from '../../config/config'
import PoiExternalLink from './PoiExternalLink'

const PoiAffiliateLinks = ({ poi, isAdmin }) => {
  const { t } = useTranslation()
  const [poiAffiliateLinks, setPoiAffiliateLinks] = useState([])

  useEffect(() => {
    const fetchPoiAffiliateLinks = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}poi-external-link?poi=${poi.id}&isAffiliateLink=true`,
        )
        setPoiAffiliateLinks(response.data)
      } catch (error) {
        // console.error('An error occurred while fetching links:', error);
      }
    }

    fetchPoiAffiliateLinks()
  }, [poi.id])

  return (
    <div>
      {poiAffiliateLinks && poiAffiliateLinks.length > 0 && (
        <div className="mt-4">
          <hr />
          <h2 className="mb-4">{t('AFFILIATE_LINKS')}</h2>
          <p>{t('AFFILIATE_LINKS_DESCRIPTION')}</p>
          <div className="d-flex flex-column gap-3">
            {poiAffiliateLinks.map((poiAffiliateLink) => (
              <PoiExternalLink
                key={poiAffiliateLink.id}
                poiExternalLink={poiAffiliateLink}
                isAdmin={isAdmin}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default PoiAffiliateLinks
